import React from 'react'
import { ApplicationModel } from '@/models/application.model'
import { ApplicationCard } from './ApplicationCard'
import { ApplicationsTable } from './ApplicationsTable'
import { useNavigate } from 'react-router-dom'
import { paths } from '@/routes/path'

type Props = {
  items: ApplicationModel[]
  viewMode?: 'grid' | 'table'
  onViewModeChange?: (mode: 'grid' | 'table') => void
  programmeNameById?: Record<string, string>
}

export const ApplicationsList: React.FC<Props> = ({
  items,
  viewMode = 'grid',
  onViewModeChange,
  programmeNameById,
}) => {
  const router = useNavigate()


  const handleView = (app: ApplicationModel) => {
    if(app.id){
      router(paths.app.applications.detail.build(app.id ?? ''))
    }
  }
  
  if (!items.length) {
    return (
      <div className="border rounded-xl p-10 text-center bg-white">
        <p className="text-gray-600">No applications found.</p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {/* Toolbar (optional) */}
      {onViewModeChange && (
        <div className="flex justify-end mb-2">
          <div className="flex gap-2 text-sm">
            <button
              onClick={() => onViewModeChange('grid')}
              className={`px-3 py-1 border rounded-md ${
                viewMode === 'grid'
                  ? 'bg-[#7b2a40] text-white border-[#7b2a40]'
                  : 'border-gray-300 text-gray-700 hover:border-[#7b2a40]'
              }`}
            >
              Grid
            </button>
            <button
              onClick={() => onViewModeChange('table')}
              className={`px-3 py-1 border rounded-md ${
                viewMode === 'table'
                  ? 'bg-[#7b2a40] text-white border-[#7b2a40]'
                  : 'border-gray-300 text-gray-700 hover:border-[#7b2a40]'
              }`}
            >
              Table
            </button>
          </div>
        </div>
      )}

      {/* Grid View */}
      {viewMode === 'grid' && (
        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {items.map((a) => (
            <ApplicationCard
              key={a.id ?? `${a.app_id}-${Math.random()}`}
              app={a}
              onView={handleView}
              programmeName={a.programme_id ? programmeNameById?.[a.programme_id] : undefined}
            />
          ))}
        </div>
      )}

      {/* Table View */}
      {viewMode === 'table' && (
        <ApplicationsTable
          items={items}
          onView={handleView}
          programmeNameById={programmeNameById}
        />
      )}
    </div>
  )
}
